import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
  import store from "../../store/index";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'LotCardWaitlist',
  props: {
    estateId: {
      required: true,
    },
  },
  emits: [""],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;
  const props = __props;
  const estateInfo = ref({});

  store.dispatch("estate/getEstate", props.estateId.toString()).then((res) => {
    estateInfo.value = res.data;
  });

const __returned__ = { emits, props, estateInfo, ref, get store() { return store } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})